import type {
  ActiveTimerResponse,
  CreatedResponse,
  StopTimerResponse,
  TimeEntryDtoPagedResult,
} from '../types';

export const mockActiveTimer: ActiveTimerResponse = {
  id: 'entry-1',
  task: {
    id: '42',
    title: 'Diseñar dashboard principal',
    project: { id: 'proj-1', name: 'KhronoxV3' },
    board: { id: 'board-1', name: 'Sprint 1' },
    status: { id: 'status-1', name: 'En progreso' },
  },
  assignee: {
    id: 'user-1',
    email: 'guillermo@acme.com',
    displayName: 'Guillermo',
    avatarUrl: null,
  },
  // 24 minutes and 18 seconds ago
  startTime: new Date(Date.now() - 24 * 60 * 1000 - 18 * 1000).toISOString(),
  durationHours: 0.41,
  description: null,
  isBillable: false,
};

export const mockCreatedResponse: CreatedResponse = { id: 'entry-99' };

export const mockStopTimerResponse: StopTimerResponse = {
  id: 'entry-1',
  startedAt: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
  endedAt: new Date().toISOString(),
  durationHours: 0.5,
};

export const mockTaskTimeEntries: TimeEntryDtoPagedResult = {
  items: [
    {
      id: 'entry-1',
      tenantId: 'tenant-1',
      task: {
        id: '42',
        title: 'Diseñar dashboard principal',
        project: { id: 'proj-1', name: 'KhronoxV3' },
        board: { id: 'board-1', name: 'Sprint 1' },
        status: { id: 'status-1', name: 'En progreso' },
      },
      user: {
        id: 'user-1',
        email: 'guillermo@acme.com',
        displayName: 'Guillermo',
        avatarUrl: null,
      },
      startTime: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
      endTime: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
      durationHours: 1.5,
      description: null,
      isBillable: false,
      createdAt: new Date().toISOString(),
      updatedAt: null,
    },
    {
      id: 'entry-2',
      tenantId: 'tenant-1',
      task: {
        id: '42',
        title: 'Diseñar dashboard principal',
        project: { id: 'proj-1', name: 'KhronoxV3' },
        board: { id: 'board-1', name: 'Sprint 1' },
        status: { id: 'status-1', name: 'En progreso' },
      },
      user: {
        id: 'user-1',
        email: 'guillermo@acme.com',
        displayName: 'Guillermo',
        avatarUrl: null,
      },
      startTime: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
      endTime: new Date(Date.now() - 23 * 60 * 60 * 1000).toISOString(),
      durationHours: 1.0,
      description: 'Primera sesión de trabajo',
      isBillable: true,
      createdAt: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
      updatedAt: null,
    },
  ],
  page: 1,
  pageSize: 20,
  totalCount: 2,
  totalPages: 1,
  hasPreviousPage: false,
  hasNextPage: false,
  firstItemOnPage: 1,
  lastItemOnPage: 2,
};

const sampleEntry = (
  id: string,
  taskTitle: string,
  displayName: string,
  durationHours: number,
  isBillable: boolean,
  description: string | null,
) => ({
  id,
  tenantId: 'tenant-1',
  task: {
    id: '42',
    title: taskTitle,
    project: { id: 'proj-1', name: 'KhronoxV3' },
    board: { id: 'board-1', name: 'Sprint 1' },
    status: { id: 'status-1', name: 'En progreso' },
  },
  user: { id: 'user-1', email: 'guillermo@acme.com', displayName, avatarUrl: null },
  startTime: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
  endTime: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
  durationHours,
  description,
  isBillable,
  createdAt: new Date().toISOString(),
  updatedAt: null,
});

export const mockProjectTimeEntries: TimeEntryDtoPagedResult = {
  items: [
    sampleEntry('entry-10', 'Diseñar dashboard principal', 'Guillermo', 1.5, true, 'Maquetado'),
    sampleEntry('entry-11', 'Tarea 1', 'Sara', 2, false, null),
    sampleEntry('entry-12', 'Tarea 2', 'Mónica', 1.25, true, 'Revisión de QA'),
  ],
  page: 1,
  pageSize: 20,
  totalCount: 3,
  totalPages: 1,
  hasPreviousPage: false,
  hasNextPage: false,
  firstItemOnPage: 1,
  lastItemOnPage: 3,
};

export const mockUserTimeEntries: TimeEntryDtoPagedResult = {
  items: [
    sampleEntry('entry-20', 'Diseñar dashboard principal', 'Guillermo', 0.5, false, null),
    sampleEntry('entry-21', 'Tarea 3', 'Guillermo', 3, true, 'Implementación'),
  ],
  page: 1,
  pageSize: 20,
  totalCount: 2,
  totalPages: 1,
  hasPreviousPage: false,
  hasNextPage: false,
  firstItemOnPage: 1,
  lastItemOnPage: 2,
};
